import { render, staticRenderFns } from "./UserReferrals.vue?vue&type=template&id=3281c9ce&scoped=true&"
import script from "./UserReferrals.vue?vue&type=script&lang=js&"
export * from "./UserReferrals.vue?vue&type=script&lang=js&"
import style0 from "./UserReferrals.vue?vue&type=style&index=0&id=3281c9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3281c9ce",
  null
  
)

export default component.exports